import React from "react";
import { useDropzone } from "react-dropzone";
import {
  dropzone_wrapper,
  active,
  dropzone_icon,
  dropzone_text,
  dropzone_button,
  dropzone_hint,
  dropzone_formats,
  format_badge,
} from "../../../styles/modules/palette_from_image.module.css";

const TEXTS = {
  es: {
    dropHere: "Suelta la imagen aquí",
    dragOrClick: "Arrastra una imagen aquí",
    select: "Seleccionar imagen",
    hint: "o haz clic para buscarla en tu dispositivo",
    formats: "Formatos admitidos",
  },
  en: {
    dropHere: "Drop the image here",
    dragOrClick: "Drag an image here",
    select: "Select image",
    hint: "or click to browse your device",
    formats: "Supported formats",
  },
  pt: {
    dropHere: "Solte a imagem aqui",
    dragOrClick: "Arraste uma imagem aqui",
    select: "Selecionar imagem",
    hint: "ou clique para procurar no dispositivo",
    formats: "Formatos aceitos",
  },
  fr: {
    dropHere: "Déposez l'image ici",
    dragOrClick: "Faites glisser une image ici",
    select: "Sélectionner une image",
    hint: "ou cliquez pour parcourir votre appareil",
    formats: "Formats acceptés",
  },
  de: {
    dropHere: "Bild hier ablegen",
    dragOrClick: "Ziehe ein Bild hierher",
    select: "Bild auswählen",
    hint: "oder klicke, um dein Gerät zu durchsuchen",
    formats: "Unterstützte Formate",
  },
};

const ACCEPTED_IMAGES = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
  "image/gif": [".gif"],
};

function Dropzone({ onDrop, locale }) {
  const texts = TEXTS[locale] || TEXTS.es;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPTED_IMAGES,
    multiple: false,
  });

  return (
    <div
      className={`${dropzone_wrapper} ${isDragActive ? active : ""}`}
      {...getRootProps({
        role: "button",
        "aria-label": texts.select,
      })}
    >
      <input {...getInputProps()} />
      <svg
        className={dropzone_icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="m21 15-5-5L5 21" />
        <path d="M12 16V7m0 0L9 10m3-3 3 3" />
      </svg>

      <p className={dropzone_text}>
        {isDragActive ? texts.dropHere : texts.dragOrClick}
      </p>
      {!isDragActive ? (
        <>
          <span className={dropzone_button}>{texts.select}</span>
          <p className={dropzone_hint}>{texts.hint}</p>
          <div className={dropzone_formats} aria-label={texts.formats}>
            {Object.values(ACCEPTED_IMAGES)
              .flat()
              .filter(extension => extension !== ".jpeg")
              .map(extension => (
                <span className={format_badge} key={extension}>
                  {extension.slice(1)}
                </span>
              ))}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default Dropzone;
